import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/language-modal.css";

interface LanguageSelectionModalProps {
  isOpen: boolean;
  onLanguageSelect: (language: string) => void;
}

const LanguageSelectionModal: React.FC<LanguageSelectionModalProps> = ({
  isOpen,
  onLanguageSelect,
}) => {
  const { i18n } = useTranslation();

  const handleLanguageSelect = (language: string) => {
    // Change the language
    i18n.changeLanguage(language);

    // Update document direction and lang attribute
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = language;

    // Store the preference in localStorage
    localStorage.setItem("apcg2026-language-selected", "true");
    localStorage.setItem("apcg2026-preferred-language", language);

    // Call the callback to close modal
    onLanguageSelect(language);
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block language-modal"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-body text-center">
            <div className="mb-4">
              <img
                src="/images/logos/apcg-ubt-standalone-logo.png"
                alt="APCG Logo"
                className="img-fluid mb-3"
                style={{ maxHeight: "80px" }}
              />
            </div>

            <h3 className="fw-700 text-dark-gray mb-1 ls-minus-1px">
              Welcome to APCG 2026
            </h3>
            <h3 className="fw-700 text-dark-gray mb-4 ls-minus-1px" dir="rtl">
              مرحباً بكم في APCG 2026
            </h3>

            <p className="fs-17 text-medium-gray mb-2 fw-500">
              Please select your preferred language
            </p>
            <p className="fs-17 text-medium-gray mb-4 fw-500" dir="rtl">
              يرجى اختيار لغتك المفضلة
            </p>

            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8">
                <div className="row align-items-center">
                  <div className="col-6">
                    <button
                      className="btn btn-gradient-apcg w-100 py-4 fw-700 fs-18 hover-box text-white border-0 shadow-sm d-flex align-items-center justify-content-center"
                      onClick={() => handleLanguageSelect("en")}
                    >
                      <i className="feather icon-feather-globe me-2 fs-20"></i>
                      <span className="ls-05px">ENGLISH</span>
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      className="btn btn-gradient-apcg w-100 py-4 fw-700 fs-18 hover-box text-white border-0 shadow-sm d-flex align-items-center justify-content-center"
                      onClick={() => handleLanguageSelect("ar")}
                    >
                      <i className="feather icon-feather-globe me-2 fs-20"></i>
                      <span className="ls-05px">العربية</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 pt-2">
              <p className="text-light-gray fs-14 mb-1 fw-400">
                You can change language anytime from the navigation menu
              </p>
              <p className="text-light-gray fs-14 mb-0 fw-400" dir="rtl">
                يمكنك تغيير اللغة في أي وقت من قائمة التنقل
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelectionModal;
